module.exports = __webpack_public_path__ + "static/media/Lato-light.1b75c6e4.eot";